import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const login = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/auth/login'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRequiredToken: false,
			/*
				로그인 실패는 401 이다(API 2.19.0 부터). `isRefresh` 기본값 `true` 로 두면
				그 401 이 토큰 갱신 경로를 타고, 갱신도 실패해 `/auth/loading` 으로 튄다.
				로그인은 갱신할 토큰이 애초에 없는 요청이다.
			*/
			isRefresh: false,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const tokenValidation = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/auth/token-validation'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const loginUsingAccessToken = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/auth/login-using-access-token'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateSelfProfile = async ({
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/auth/profile'
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRefresh: false,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateSelfPassword = async ({
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/auth/password'
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRefresh: false,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateSelfProfileImage = async ({
	body = {},
	query = {},
	customHeaders = {},
	files = [],
}: {
	body?: { [key: string]: any }
	query?: { [key: string]: any }
	customHeaders?: { [key: string]: any }
	files?: File[]
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/auth/profile-image'
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: Api.createFormData(body, files),
			query: query,
			customHeaders: {
				...customHeaders,
				'Content-Type': 'multipart/form-data',
			},
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const authApi = {
	login: login,
	tokenValidation: tokenValidation,
	loginUsingAccessToken: loginUsingAccessToken,
	updateSelfProfile: updateSelfProfile,
	updateSelfPassword: updateSelfPassword,
	updateSelfProfileImage: updateSelfProfileImage,
}

export default authApi
